/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetUsersProfilePaymentIdQueryResponse, GetUsersProfilePaymentIdPathParams, GetUsersProfilePaymentId400 } from "../entities/GetUsersProfilePaymentPaymentId";

function getGetUsersProfilePaymentPaymentIdUrl(payment_id: GetUsersProfilePaymentIdPathParams["payment_id"]) {
  const res = { method: 'GET', url: `/users/profile/payment/${payment_id}` as const }  
  return res
}

/**
 * @description Получение статуса платежа
 * @summary Получение статуса платежа
 * {@link /users/profile/payment/:payment_id}
 */
export async function getUsersProfilePaymentPaymentId(payment_id: GetUsersProfilePaymentIdPathParams["payment_id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetUsersProfilePaymentIdQueryResponse, ResponseErrorConfig<GetUsersProfilePaymentId400>, unknown>({ method : "GET", url : getGetUsersProfilePaymentPaymentIdUrl(payment_id).url.toString(), ... requestConfig })  
  return res.data
}